import { Lock, Mail } from 'lucide-react';

/**
 * PaidFeaturePaywall — informational notice shown in place of a paid
 * feature's UI when the current user is not on a paid plan. Mirrors the
 * backend gate (which returns HTTP 403 with the same message text) so
 * users see a consistent story whether they trip the client-side check
 * or the server-side one.
 */
export default function PaidFeaturePaywall({ featureName, tone = 'amber' }) {
  const toneClasses = {
    amber: 'border-amber-300 bg-amber-50 text-amber-900',
    sky: 'border-sky-300 bg-sky-50 text-sky-900',
    indigo: 'border-indigo-300 bg-indigo-50 text-indigo-900',
  }[tone] || 'border-amber-300 bg-amber-50 text-amber-900';

  return (
    <div
      className={`rounded-lg border-2 border-dashed ${toneClasses} p-6 text-center space-y-3`}
      data-testid="paid-feature-paywall"
    >
      <div className="flex justify-center">
        <div className="w-12 h-12 rounded-full bg-white/70 flex items-center justify-center">
          <Lock className="w-6 h-6" />
        </div>
      </div>
      <h3 className="text-base font-semibold" data-testid="paywall-feature-name">
        {featureName} — paid feature
      </h3>
      <p className="text-sm max-w-md mx-auto">
        This integration is available on a <strong>paid subscription</strong>.
        Contact PFD support to upgrade your account and unlock direct uploads.
      </p>
      <a
        href="mailto:support@precisionfishdetection.com?subject=Paid%20subscription%20enquiry"
        className="inline-flex items-center gap-1.5 text-sm font-medium underline underline-offset-2 hover:no-underline"
        data-testid="paywall-contact-link"
      >
        <Mail className="w-3.5 h-3.5" />
        Contact PFD support
      </a>
    </div>
  );
}
